module.exports = __webpack_public_path__ + "img/calendar.0cbb64b3.svg";